import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { DrawerFormDataType } from '@/types';

import { useDeleteChannel } from '../api/delete-channel';
import { ChannelType } from '../types';

type TBroadcastersControllersReturn = {
  broadcastersDialog: ReturnType<typeof useDisclosureWithData<ChannelType>>;
  broadcastersDrawer: ReturnType<typeof useDisclosureWithData<DrawerFormDataType<ChannelType>>>;
  handleDeleteBroadcasters: () => void;
};

export function useBroadcastersControllers(): TBroadcastersControllersReturn {
  const broadcastersDialog = useDisclosureWithData<ChannelType>();
  const broadcastersDrawer = useDisclosureWithData<DrawerFormDataType<ChannelType>>();
  const { mutate: deleteChannel } = useDeleteChannel();

  const handleDeleteBroadcasters = () => {
    if (broadcastersDialog.data) {
      deleteChannel(
        {
          id: broadcastersDialog.data.id,
        },
        {
          onSuccess: () => {
            broadcastersDialog.close();
          },
        }
      );
    }
  };

  return {
    broadcastersDialog,
    broadcastersDrawer,
    handleDeleteBroadcasters,
  };
}
